// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1___f77033360d891d9ea68","cls2":"NewsInteractionBar-cls2___4dfcdca6f2623649b91 NewsInteractionBar-cls1___f77033360d891d9ea68"};